import Vue from 'vue';

Vue.directive('focus-on-page-load', {
  mounted(el, binding) {
    if (binding.value.active || !binding.value) el.focus();
  },
});
